<template>
  <div class="payResult">
    <div class="pay-success" v-if="result==1">
      <img class="img-success" :src="successIconUrl">
      <p>{{msg}}</p>
    </div>
    <div class="pay-error" v-if="result==0">
      <img class="img-error" :src="errorIconUrl">
      <p>缴费失败，请重新缴费</p>
    </div>
    <div class="advertising" style="margin: 30% 0px;" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="80%"/>
    </div>
  </div>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    name: "payResult",
    data() {
      return {
        url: "", //展示图片
        cUrl: "", //点击跳转地址
        title: "",
        active: "2",
        carNum: "",
        result: "",
        msg: "缴费成功，请尽快离场",
        successIconUrl: "../static/img/success.png",
        errorIconUrl: "../static/img/error.png",
        reloadFlag: false

      };
    },
    methods: {
      getResult() {
        this.result = this.$route.query.result;
        this.msg = this.$route.query.msg;
        this.type = this.$route.query.type;
        this.money = this.$route.query.money;
      },
      //广告加载
      getAdvertisingInfo() {
        if (this.type == "wallet"&&this.money>=this.$api.money&&this.result==1) {
          this.url = this.$api.newYearImage;
          this.cUrl = this.$api.newYearUrl;
        } else {
          this.$axios({
              url: this.$api.receipt,
              method: "get",
            })
            .then(res => {
              this.url = res.data.data.creativeImg.creativeUrl;
              this.cUrl = res.data.data.landingPage;
              let trackUrl = res.data.data.trackUrl;
              this.$axios({
                url: trackUrl,
                method: "get",
              }).then(res => {
                console.log(res)
              });
              console.log(res.data);
            })
        }
      },
      clickUrl() {
        window.location.href = this.cUrl;
      }
    },
    created() {},
    mounted() {
      this.getResult();
      this.getAdvertisingInfo();
    },
  };
</script>

<style scoped>
  .payResult {
    min-height: 100%;
    height: 100%;
    width: 100%;
    max-width: 100%;
    background-color: #FFF;
    float: left;
    margin-top: 15%;
  }

  .pay-success,
  .pay-error {
    margin-top: 15%;
  }

  .pay-success,
  .pay-error {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .img-success,
  .img-error {
    height: 50px;
    width: 50px;
    text-align: center;
  }

  .pay-success p {
    color: #1296db;
  }

  .pay-error p {
    color: red;
  }

  .adsense-space {
    width: 96%;
    margin-left: 2%;
    height: 25%;
    margin-top: 20px;

  }

  .adsense-space img {
    height: 100%;
    width: 100%;
    border-radius: 8px;
  }

  .complete {
    width: 100%;
    text-align: center;
  }

  .van-button {
    margin-top: 30px;
    height: 36px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/payResult.vue